import axios from '../utils/axios';

export const getLocations = () => {
  return axios.get('users/locations').then(response => response.data);
}

export const getSrids = () => {
  return axios.get('uploads/srids').then(response => response.data);
}
export const createProject = (data) => {
  return axios.post('projects/create', data).then(response => response.data);
}
export const createMultimediaProject = data => {
  return axios.post('projects/create/multimedia', data).then(response => response.data);
}
export const createMultimediaSubProject = data => {
  return axios.post('/projects/create/multimediasubproject', data).then(response => response.data);
}
export const uploadImage = (file, id, first, uploadProgressFunc) => {
  return axios.post(
    `uploads/uploadPicture/${file.name}/${id}/${first}/${file.size}`, file,
    {
      headers: {'content-type': 'image/jpeg', 'Accept': 'application/json'},
      onUploadProgress: uploadProgressFunc,
    });
}
export const uploadMultimedia = (file, type, id, subProjId, uploadProgressFunc) => {
  return axios.post(
    `/uploads/${type}/${file.path}/${id}/${file.size}/${subProjId}`, file,
    {
      headers: {'content-type': 'application/octet-stream', 'Accept': 'application/json'},
      onUploadProgress: uploadProgressFunc,
    });
}
export const uploaded = (id,imageCount) => {
  return axios.get(`uploads/uploadDone/${id}/${imageCount}`).then(response => response.data);
}
export const multimediaUploaded = subProjId => {
  return axios.get(`/uploads/done/${subProjId}`).then(response => response.data);
}
export const getUploadedImages = (id) => {
  return axios.get(`uploads/uploadedImages/${id}`).then(response => response.data);
}
export const reuploadPicture = (file, id, uploadProgressFunc) => {
  return axios.post(
    `uploads/reuploadPicture/${file.name}/${id}/${file.size}`,file,
    {
      headers: {'content-type': 'image/jpeg', 'Accept': 'application/json'},
      onUploadProgress: uploadProgressFunc,
    });
}
export const reuploadDone = (data) => {
  return axios.post(`uploads/reuploadDone`,data).then(response => response.data);
}
export const processingImage = subProjId => {
  return axios.get(`multimediaapi/singleimgengine/v1/processsingleimg?subprojectid=${subProjId}`).then(response => response.data);
}
